export const SPARK_RUN_ROUTE_REGEX =
  /^\/spark\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
export const BOARDS_ROUTE_REGEX =
  /^\/boards\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const SPARK_BUILDER_ROUTE_REGEX =
  /^\/spark\/builder\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const SPARK_RUN_DETAILS_ROUTE_REGEX =
  /^\/spark\/run\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const NUMERIC_TWO_DECIMAL_REGEX = /^-?\d*\.?\d{0,2}$/;
export const QUESTION_MARK_LEADING_PATTERN = /^(\?+)/;
export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,}$/;
export const VIDEO_URL_PATTERN =
  /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)|(?:https?:\/\/)?(?:www\.)?youtu\.be\/([a-zA-Z0-9_-]+)|(https:\/\/www\.loom\.com\/share\/[a-zA-Z0-9_-]+(\?sid=[a-zA-Z0-9_-]+)?)$/;

export const PHONE_NUMBER_PATTERN = /^\d{10}$/;

export const ESCAPE_REGEX_SPECIAL_CHARS_PATTERN = /[-\/\\^$*+?.()|[\]{}]/g;

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// TipTap-specific regular expressions have been moved to SparkUp/SparkUpUI/src/external/TipTapEditor/regex.ts
